import type {
  ManualPaymentMethod,
  PatchAdminV1StoresStoreIdPaymentMethodsIdBody,
  PostAdminV1StoresStoreIdPaymentMethodsBody,
} from '@nucleus-commerce/api-client/admin';
import { zeroMoney } from '@nucleus-commerce/core';

import type {
  PaymentMethodFormInput,
  PaymentMethodFormOutput,
} from '../schemas/payment-method-form-schema';

const orNull = (value: string) => (value === '' ? null : value);

export function emptyPaymentMethodForm(currency: string, position: number): PaymentMethodFormInput {
  return {
    key: '',
    name: '',
    description: '',
    instructions: '',
    fee: zeroMoney(currency),
    minOrder: null,
    maxOrder: null,
    isActive: true,
    position,
  };
}

export function fromPaymentMethod(method: ManualPaymentMethod): PaymentMethodFormInput {
  return {
    key: method.key,
    name: method.name,
    description: method.description ?? '',
    instructions: method.instructions ?? '',
    fee: method.fee,
    minOrder: method.minOrder,
    maxOrder: method.maxOrder,
    isActive: method.isActive,
    position: method.position,
  };
}

/** An empty fee means none; the backend defaults to zero when the field is omitted. */
export function toPaymentMethodCreate(
  values: PaymentMethodFormOutput,
): PostAdminV1StoresStoreIdPaymentMethodsBody {
  return {
    key: values.key,
    name: values.name,
    description: orNull(values.description),
    instructions: orNull(values.instructions),
    ...(values.fee ? { fee: values.fee } : {}),
    minOrder: values.minOrder,
    maxOrder: values.maxOrder,
    isActive: values.isActive,
    position: values.position,
  };
}

export function toPaymentMethodUpdate(
  values: PaymentMethodFormOutput,
  currency: string,
): PatchAdminV1StoresStoreIdPaymentMethodsIdBody {
  return {
    name: values.name,
    description: orNull(values.description),
    instructions: orNull(values.instructions),
    fee: values.fee ?? zeroMoney(currency),
    minOrder: values.minOrder,
    maxOrder: values.maxOrder,
    isActive: values.isActive,
    position: values.position,
  };
}
